import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import {
    setAppCustomTitle
} from "../../reducers/ThemeOptions";
import { Form, Button, FormGroup, Input, InputGroup, Label, Modal, ModalHeader, ModalBody } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { CheckUlrValid, formatDateTime, isValidURL, parseJSON, showToast, translateContent } from "../../Common/Appcommon";
import Loading from "../../Common/Loading";
import requestApiService from "../../services/requestApi.service";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';

const ServerInfo = (props) => {
    const [showSecret, setShowSecret] = useState(true);
    const [showLoader, setShowLoader] = useState(false);
    const [data, setData] = useState({});
    const [isUpdate, setIsUpdate] = useState(false);
    const [webhookShowLoader, setWebhookShowLoader] = useState(false);
    const { rowData, getSaveData, onAction, toggle } = props;
    const { handleSubmit, control, reset, formState: { errors } ,trigger} = useForm();

    useEffect(() => {
        if(!!rowData["advanced settings"]){
            setIsUpdate(true);
        }
        setData(rowData);
    }, [rowData]);

    const advancedSettingsFields = [
        {
            label: "Server URL",
            name: "server_url",
            type: "text",
            description: "We’ll send a POST request to this URL after every call.",
            placeholder: "Enter your server URL",
            required: true,
            autoComplete :"off"
        },
        {
            label: "Server URL Secret (Optional)",
            name: "secret",
            type: "text",
            description: "Add a secret key for security.",
            placeholder: "Enter your secret key",
            required: false,
            autoComplete :"off"
        },
    ];

    const handleChange = (e, type = "") => {
        let {name, value} = e.target;
        if(type === "adv_settings"){
            let adv_settings = {...parseJSON(data["advanced settings"]) };
            adv_settings[name] = value;
            adv_settings['updatedon'] = formatDateTime(new Date(), 'yyyy-MM-dd HH:mm:ss');
            setData(prevData => ({
                ...prevData,
                "advanced settings": JSON.stringify(adv_settings)
            }));
        }
    };



    const submitBtnClick = async (input, e) => {
        e.preventDefault();
        setShowLoader(true);
        let adv_set = data["advanced settings"];
        adv_set = parseJSON(adv_set);
        let isValid = CheckUlrValid(adv_set["server_url"]);
        if(isValid){
            const params = {
                ENTITY: "AIPROCESSOR",
                OPERATION: "SAVE_AGENT_SERVER_DATA",
                FORMINPUT: data,
                AGENTID: data['table_250_id'],
                isOtherApiReq: true,
            };
            try {
                let response = await requestApiService.processServerRequest(params);
                if(response.issuccess){
                    showToast(translateContent("vm.agent.action.serverurl.success"));
                    getSaveData(onAction);
                    props.onChange("advanced settings", data["advanced settings"]);
                    toggle();
                }
            }catch(e){
                console.error(e);
            }
        }else{
            showToast(translateContent("vm.agent.action.serverurl.error"), "top-right", "error");
        }
        // await props.onSubmit(data, "adv_set");
        setShowLoader(false);
    }

    const handleTestWebhook = async () => {
        try{
            setWebhookShowLoader(true);
            let adv_set = data["advanced settings"];
            adv_set = parseJSON(adv_set);
            let isValid = CheckUlrValid(adv_set["server_url"]);
            if(isValid){
                const params = {
                    ENTITY: "AIPROCESSOR",
                    OPERATION: "SENT_TEST_WEBHOOK",
                    FORMINPUT: data,
                    type: "call_log",
                    isOtherApiReq: true,
                };
                let response = await requestApiService.processServerRequest(params);
                if(response.issuccess){
                    showToast(translateContent("vm.agent.action.serverurl.send"));
                }
            }else{
                showToast(translateContent("vm.agent.action.serverurl.error"), "top-right", "error");
            }
        }catch(e){
            console.error(e);
        }
        setWebhookShowLoader(false);
    }
    let adv_set = data?.["advanced settings"] != undefined ? parseJSON(data["advanced settings"]) : []; 

    return (
        <Fragment>
            <Form 
                className="ms-3 me-3" 
                onSubmit={handleSubmit(submitBtnClick)}
            >
                {
                    advancedSettingsFields && advancedSettingsFields.map((field) => {
                        const { label, name, type, placeholder, description, isDisabled, autoComplete, required } = field;
                        return(
                            <FormGroup>
                                <Label for={name} className="agent-header-title mb-0">{label}</Label>
                                <p className="mb-1">{description}</p>
                                <Controller
                                    name={name}
                                    control={control}
                                    rules={{
                                        required: (required ? (!adv_set[name] ? "Please provide valid " + label : false) : false),
                                        validate: () => {
                                            if(name === "secret"){
                                                return true;
                                            }
                                            try {
                                                // If `value` is not a valid absolute URL, this will throw
                                                new URL(adv_set[name]);
                                                return true;
                                            } catch {
                                                return "Please provide valid " + label;
                                            }
                                        }
                                    }}
                                    render={({ field }) => (
                                        <>
                                            <InputGroup>
                                                <Input
                                                    {...field}
                                                    name={name}
                                                    type={showSecret && name === "secret" ? "password" : type}
                                                    placeholder={placeholder}
                                                    value={adv_set[name] ?? ""}
                                                    className={`${errors[name] ? 'is-invalid' : ''}`}
                                                    onChange={e => {
                                                        handleChange(e, "adv_settings");
                                                        field.onChange(e);
                                                    }}
                                                    disabled={isDisabled}
                                                    autoComplete= {autoComplete}
                                                />
                                                {
                                                    name === "secret" && 
                                                        <div className={"input-group-text cursor-pointer"} onClick={ e => setShowSecret(!showSecret)}>
                                                        {
                                                            showSecret ? (
                                                                <i class="fi fi-rr-eye-crossed"></i>
                                                            ) : (
                                                                <i class="fi fi-rr-eye"></i>
                                                            )
                                                        }
                                                    </div>
                                                }
                                            </InputGroup>
                                        </>
                                    )}
                                />
                                {errors[name] && <em className={`error invalid-feedback`}>{errors[name].message}</em>}
                            </FormGroup>
                        )
                    })
                }
                <div className="d-flex">
                    <div className="me-auto">
                        <Loading 
                            showLoader={webhookShowLoader} 
                            mainContent={
                                <Button className="theme-bg-g" type="button" onClick={e => handleTestWebhook(e)}>
                                    Test Webhook
                                </Button>
                            } 
                        />
                    </div>
                    <div className="ms-auto">
                        <Loading 
                            showLoader={showLoader} 
                            mainContent={
                                <Button className="theme-bg-g" type="submit">
                                    {
                                        !isUpdate ? (
                                            <>
                                                <FontAwesomeIcon icon={faPlus} /> Add Action
                                            </>
                                        ) : (
                                            <>
                                                Update
                                            </>
                                        )
                                    }
                                </Button>
                            } 
                        />
                    </div>
                </div>
            </Form>
        </Fragment>
    )
}

const mapStateToProps = state => ({
    appCustomTitle: state.ThemeOptions.appCustomTitle
});

const mapDispatchToProps = dispatch => ({
    setAppCustomTitle: title => dispatch(setAppCustomTitle(title)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ServerInfo);
